import { httpGet } from '../../components/utils';
import { getFullUrl } from '../utils';
import { QueryParams } from '../types/QueryParams';

export const apiGet = async <TData>(url: string, queryParams: QueryParams = {}): Promise<TData> => {
    const fullUrl = getFullUrl(url, queryParams);
    const { data } = await httpGet(fullUrl);
    return data as TData;
};
